module.exports = __webpack_public_path__ + "img/tsts_bg@2x.8c8d3b7b.png";